// Logs.js - Componente de Gestão de Logs do Sistema (COM PAGINAÇÃO E EXPORTAÇÃO CSV/PDF)
// 🔥 ADICIONADO: Botão para apagar logs individuais e em massa
// 🔥 ADICIONADO: Suporte para tipo "Clientes"
// 🔥 ADICIONADO: Suporte para tipo "Fornecedores"
// 🔥 ADICIONADO: Suporte para "Recebimentos", "Transferências", "Cotações", "Serviços",
//                "Arquivo", "Eliminação", "Entrada de Stock", "Inventario", "Movimentos",
//                "Armazéns", "Categorias", "Criar Produtos", "Listar Produtos", "Logs"
// 🔥 MODIFICADO: Items por página reduzido para 9
// 🔥 CORRIGIDO: Ícones SVG, cores e labels alinhados com o backend (routes/logs.js)
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import './Logs.css';
import { Icon } from './SharedComponents';

// ==============================================
// IMPORTAÇÕES DO @react-pdf/renderer
// ==============================================
import {
    Document,
    Page,
    Text,
    View,
    StyleSheet,
    Svg,
    Path,
    G
} from '@react-pdf/renderer';

// ==============================================
// COMPONENTES DE ÍCONES SVG
// ==============================================
const IconLock = () => (
    <Svg width={8} height={8} viewBox="0 0 24 24">
        <Path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" fill="#1d4ed8" />
    </Svg>
);

const IconUsers = () => (
    <Svg width={8} height={8} viewBox="0 0 24 24">
        <Path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" fill="#059669" />
    </Svg>
);

const IconBuilding = () => (
    <Svg width={8} height={8} viewBox="0 0 24 24">
        <Path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z" fill="#d97706" />
    </Svg>
);

const IconClientes = () => (
    <Svg width={8} height={8} viewBox="0 0 24 24">
        <Path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" fill="#2563eb" />
        <Path d="M16 12c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm4 2c-1.33 0-4 .67-4 2v2h8v-2c0-1.33-2.67-2-4-2z" fill="#2563eb" opacity="0.7" />
    </Svg>
);

const IconFornecedores = () => (
    <Svg width={8} height={8} viewBox="0 0 24 24">
        <Path d="M20 8h-2.81c-.45-.78-1.07-1.45-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5s-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63c-.75.51-1.38 1.18-1.82 1.96H4c-1.1 0-2 .9-2 2v4c0 .55.45 1 1 1h2v3c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-3h8v3c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-3h2c.55 0 1-.45 1-1v-4c0-1.1-.9-2-2-2zm-12 4H5v-2h3v2zm9 0h-3v-2h3v2z" fill="#d97706" />
        <Path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z" fill="#d97706" opacity="0.7" />
    </Svg>
);

const IconGear = () => (
    <Svg width={8} height={8} viewBox="0 0 24 24">
        <Path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.07.62-.07.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z" fill="#dc2626" />
    </Svg>
);

const IconLicense = () => (
    <Svg width={8} height={8} viewBox="0 0 24 24">
        <Path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5L12 1zm0 2.18l7 3.12v4.7c0 4.83-3.43 9.11-7 10.16-3.57-1.05-7-5.33-7-10.16V6.3l7-3.12z" fill="#7c3aed" />
        <Path d="M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 8c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z" fill="#7c3aed" />
    </Svg>
);

const IconFinance = () => (
    <Svg width={8} height={8} viewBox="0 0 24 24">
        <Path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z" fill="#2563eb" />
    </Svg>
);

const IconSales = () => (
    <Svg width={8} height={8} viewBox="0 0 24 24">
        <Path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z" fill="#0284c7" />
        <Path d="M7 10h2v7H7zm4-3h2v10h-2zm4-3h2v13h-2z" fill="#0284c7" />
    </Svg>
);

const IconStock = () => (
    <Svg width={8} height={8} viewBox="0 0 24 24">
        <Path d="M20 6h-4V4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM10 4h4v2h-4V4zm10 16H4V8h16v12z" fill="#d97706" />
        <Path d="M8 12h2v4H8zm6 0h2v4h-2zm-3 0h2v4h-2z" fill="#d97706" />
    </Svg>
);

const IconReminder = () => (
    <Svg width={8} height={8} viewBox="0 0 24 24">
        <Path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z" fill="#d32f2f" />
    </Svg>
);

// ==============================================
// 🔥 NOVOS ÍCONES SVG PARA OS NOVOS TIPOS
// ==============================================
const IconRecebimento = () => (
    <Svg width={8} height={8} viewBox="0 0 24 24">
        <Path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4v-4h16v4zm0-10H4V4h16v4zM8 12h2v2H8v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2z" fill="#10b981" />
    </Svg>
);

const IconTransferencia = () => (
    <Svg width={8} height={8} viewBox="0 0 24 24">
        <Path d="M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z" fill="#6366f1" />
    </Svg>
);

const IconCotacao = () => (
    <Svg width={8} height={8} viewBox="0 0 24 24">
        <Path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" fill="#ec4899" />
    </Svg>
);

const IconServicos = () => (
    <Svg width={8} height={8} viewBox="0 0 24 24">
        <Path d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z" fill="#16a34a" />
    </Svg>
);

const IconArquivo = () => (
    <Svg width={8} height={8} viewBox="0 0 24 24">
        <Path d="M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H4V4h16v16zM8 7h8v2H8V7zm4 10l-4-4h2.5v-3h3v3H16l-4 4z" fill="#6b7280" />
    </Svg>
);

const IconEliminacao = () => (
    <Svg width={8} height={8} viewBox="0 0 24 24">
        <Path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" fill="#dc2626" />
    </Svg>
);

const IconEntradaStock = () => (
    <Svg width={8} height={8} viewBox="0 0 24 24">
        <Path d="M20 6h-4V4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM10 4h4v2h-4V4zm-2 12l-2-2 1.41-1.41L8 13.17V9h2v4.17l.59-.59L12 14l-2 2z" fill="#059669" />
    </Svg>
);

const IconInventario = () => (
    <Svg width={8} height={8} viewBox="0 0 24 24">
        <Path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-5h2v5zm4 0h-2V7h2v10zm4 0h-2v-3h2v3z" fill="#0ea5e9" />
    </Svg>
);

const IconCriarProduto = () => (
    <Svg width={8} height={8} viewBox="0 0 24 24">
        <Path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10h-4v4h-2v-4H7v-2h4V7h2v4h4v2z" fill="#8b5cf6" />
    </Svg>
);

const IconCategoria = () => (
    <Svg width={8} height={8} viewBox="0 0 24 24">
        <Path d="M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84l3.96-5.58c.25-.35.25-.81 0-1.16l-3.96-5.58z" fill="#a855f7" />
    </Svg>
);

const IconListarProdutos = () => (
    <Svg width={8} height={8} viewBox="0 0 24 24">
        <Path d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z" fill="#06b6d4" />
    </Svg>
);

const IconMovimentos = () => (
    <Svg width={8} height={8} viewBox="0 0 24 24">
        <Path d="M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z" fill="#f59e0b" />
    </Svg>
);

const IconArmazem = () => (
    <Svg width={8} height={8} viewBox="0 0 24 24">
        <Path d="M20 8h-2.81c-.45-.78-1.07-1.45-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5s-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63c-.75.51-1.38 1.18-1.82 1.96H4c-1.1 0-2 .9-2 2v4c0 .55.45 1 1 1h2v3c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-3h8v3c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-3h2c.55 0 1-.45 1-1v-4c0-1.1-.9-2-2-2zM8 10H5V8h3v2zm5 0h-3V8h3v2zm5 0h-3V8h3v2z" fill="#78350f" />
    </Svg>
);

const IconLogs = () => (
    <Svg width={8} height={8} viewBox="0 0 24 24">
        <Path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 14H7v-2h4v2zm0-4H7v-2h4v2zm0-4H7V7h4v2zm6 8h-4v-2h4v2zm0-4h-4v-2h4v2zm0-4h-4V7h4v2z" fill="#475569" />
    </Svg>
);

// ==============================================
// MAPEAMENTO DE ÍCONES SVG POR TIPO
// ==============================================
const tipoIconSVG = {
    'Autenticação': <IconLock />,
    'Utilizadores': <IconUsers />,
    'Empresas': <IconBuilding />,
    'Clientes': <IconClientes />,
    'Fornecedores': <IconFornecedores />,
    'Sistema': <IconGear />,
    'Licenças': <IconLicense />,
    'Financeiro': <IconFinance />,
    'Vendas': <IconSales />,
    'Stock': <IconStock />,
    'Serviços': <IconServicos />,
    'Lembretes': <IconReminder />,
    'Arquivo': <IconArquivo />,
    'Eliminação': <IconEliminacao />,
    'Entrada de Stock': <IconEntradaStock />,
    'Inventario': <IconInventario />,
    'Criar Produtos': <IconCriarProduto />,
    'Categorias': <IconCategoria />,
    'Listar Produtos': <IconListarProdutos />,
    'Movimentos': <IconMovimentos />,
    'Armazéns': <IconArmazem />,
    'Cotações': <IconCotacao />,
    'Recebimentos': <IconRecebimento />,
    'Transferências': <IconTransferencia />,
    'Logs': <IconLogs />
};

// ==============================================
// MAPEAMENTO DE CORES PARA TIPOS NO PDF
// ==============================================
const tipoColors = {
    'Autenticação': { bg: '#dbeafe', text: '#1d4ed8', border: '#93c5fd' },
    'Utilizadores': { bg: '#d1fae5', text: '#059669', border: '#6ee7b7' },
    'Empresas': { bg: '#fef3c7', text: '#d97706', border: '#fcd34d' },
    'Clientes': { bg: '#dbeafe', text: '#2563eb', border: '#93c5fd' },
    'Fornecedores': { bg: '#fef3c7', text: '#d97706', border: '#fcd34d' },
    'Sistema': { bg: '#fee2e2', text: '#dc2626', border: '#fca5a5' },
    'Licenças': { bg: '#ede9fe', text: '#7c3aed', border: '#c4b5fd' },
    'Financeiro': { bg: '#dbeafe', text: '#2563eb', border: '#93c5fd' },
    'Vendas': { bg: '#e0f2fe', text: '#0284c7', border: '#7dd3fc' },
    'Stock': { bg: '#fef3c7', text: '#d97706', border: '#fcd34d' },
    'Serviços': { bg: '#dcfce7', text: '#16a34a', border: '#86efac' },
    'Lembretes': { bg: '#fce4ec', text: '#d32f2f', border: '#ef9a9a' },
    'Arquivo': { bg: '#f1f5f9', text: '#6b7280', border: '#cbd5e1' },
    'Eliminação': { bg: '#fee2e2', text: '#dc2626', border: '#fca5a5' },
    'Entrada de Stock': { bg: '#d1fae5', text: '#059669', border: '#6ee7b7' },
    'Inventario': { bg: '#e0f2fe', text: '#0ea5e9', border: '#7dd3fc' },
    'Criar Produtos': { bg: '#ede9fe', text: '#8b5cf6', border: '#c4b5fd' },
    'Categorias': { bg: '#f3e8ff', text: '#a855f7', border: '#d8b4fe' },
    'Listar Produtos': { bg: '#cffafe', text: '#06b6d4', border: '#67e8f9' },
    'Movimentos': { bg: '#fef3c7', text: '#f59e0b', border: '#fcd34d' },
    'Armazéns': { bg: '#fef3c7', text: '#78350f', border: '#fcd34d' },
    'Cotações': { bg: '#fce7f3', text: '#ec4899', border: '#f9a8d4' },
    'Recebimentos': { bg: '#d1fae5', text: '#10b981', border: '#6ee7b7' },
    'Transferências': { bg: '#e0e7ff', text: '#6366f1', border: '#a5b4fc' },
    'Logs': { bg: '#f1f5f9', text: '#475569', border: '#cbd5e1' }
};

// ==============================================
// ESTILOS DO PDF MELHORADOS
// ==============================================
const pdfStyles = StyleSheet.create({
    page: {
        padding: 35,
        backgroundColor: '#ffffff',
        paddingTop: 30,
        paddingBottom: 30
    },

    // HEADER
    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '2 solid #4f46e5',
        paddingBottom: 12,
        marginBottom: 18
    },
    headerLeft: {
        flex: 1
    },
    headerRight: {
        flex: 1,
        alignItems: 'flex-end'
    },
    headerTitle: {
        fontSize: 20,
        fontWeight: 'bold',
        color: '#4f46e5',
        letterSpacing: 0.5
    },
    headerSubtitle: {
        fontSize: 9,
        color: '#6b7280',
        marginTop: 2,
        letterSpacing: 0.3
    },
    headerDate: {
        fontSize: 9,
        color: '#4f46e5',
        backgroundColor: '#eef2ff',
        padding: '5 14',
        borderRadius: 20,
        fontWeight: 'medium',
        marginBottom: 4
    },
    headerFiltro: {
        fontSize: 8,
        color: '#6b7280',
        backgroundColor: '#f3f4f6',
        padding: '3 12',
        borderRadius: 20,
        fontWeight: 'medium'
    },

    // STATS
    statsContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 6,
        marginBottom: 18,
        backgroundColor: '#f8fafc',
        padding: 10,
        borderRadius: 8,
        border: '1 solid #e5e7eb'
    },
    statItem: {
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: '#ffffff',
        padding: '4 12',
        borderRadius: 6,
        border: '1 solid #e5e7eb',
        fontSize: 8,
        gap: 4
    },
    statNumber: {
        fontWeight: 'bold',
        color: '#4f46e5',
        fontSize: 10,
        marginRight: 2
    },
    statLabel: {
        color: '#6b7280',
        fontSize: 8
    },

    // TABLE
    tableTitle: {
        fontSize: 10,
        fontWeight: 'bold',
        color: '#1e293b',
        marginBottom: 6
    },
    tableHeader: {
        flexDirection: 'row',
        backgroundColor: '#4f46e5',
        borderTopLeftRadius: 6,
        borderTopRightRadius: 6,
        minHeight: 30,
        alignItems: 'center'
    },
    tableHeaderCell: {
        fontSize: 7.5,
        fontWeight: 'bold',
        color: '#ffffff',
        padding: '6 6',
        textTransform: 'uppercase',
        letterSpacing: 0.8
    },
    tableRow: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        borderBottomColor: '#f1f5f9',
        minHeight: 26,
        alignItems: 'center',
        paddingVertical: 2
    },
    tableRowEven: {
        backgroundColor: '#fafbfc'
    },
    tableRowLast: {
        borderBottomWidth: 0
    },
    tableCellDate: {
        fontSize: 6.5,
        color: '#1e293b',
        padding: '4 6',
        flex: 1.1
    },
    tableCellTipo: {
        padding: '2 4',
        flex: 0.9
    },
    tableCellAcao: {
        fontSize: 7,
        fontWeight: 'medium',
        color: '#1e293b',
        padding: '4 6',
        flex: 1.4
    },
    tableCellUsuario: {
        fontSize: 6.5,
        color: '#1e293b',
        padding: '4 6',
        flex: 1.2
    },
    tableCellDetalhes: {
        fontSize: 6.5,
        color: '#475569',
        padding: '4 6',
        flex: 1.8
    },

    // BADGE TIPO
    tipoBadge: {
        padding: '2 8',
        borderRadius: 20,
        fontSize: 6,
        fontWeight: 'bold',
        textAlign: 'center',
        minWidth: 40,
        borderWidth: 1
    },

    // RELATIVE TIME
    relativeTime: {
        fontSize: 5.5,
        color: '#94a3b8',
        marginTop: 1,
        fontStyle: 'italic'
    },
    usuarioEmail: {
        fontSize: 5,
        color: '#94a3b8',
        marginTop: 1
    },

    // FOOTER
    footer: {
        marginTop: 20,
        paddingTop: 12,
        borderTop: '1 solid #e5e7eb',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    footerText: {
        fontSize: 7,
        color: '#94a3b8'
    },

    // ICON CONTAINER
    iconContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 4
    }
});

// ==============================================
// COMPONENTE PDF - SEM NOMES DOS UTILIZADORES
// ==============================================
const LogsPDFDocument = ({
    logs,
    stats,
    formatDate,
    getRelativeTime,
    filtroDescricao
}) => (
    <Document>
        <Page size="A4" style={pdfStyles.page} wrap>
            {/* HEADER */}
            <View style={pdfStyles.header} fixed>
                <View style={pdfStyles.headerLeft}>
                    <Text style={pdfStyles.headerTitle}>Relatório de Logs</Text>
                    <Text style={pdfStyles.headerSubtitle}>Registo de atividades do sistema</Text>
                </View>
                <View style={pdfStyles.headerRight}>
                    <Text style={pdfStyles.headerDate}>
                        {new Date().toLocaleString('pt-PT', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit'
                        })}
                    </Text>
                    <Text style={pdfStyles.headerFiltro}>
                        {filtroDescricao || 'Todos os logs'}
                    </Text>
                </View>
            </View>

            {/* STATS */}
            <View style={pdfStyles.statsContainer}>
                <View style={pdfStyles.statItem}>
                    <Text style={pdfStyles.statNumber}>{logs.length}</Text>
                    <Text style={pdfStyles.statLabel}>Total</Text>
                </View>
                {stats.autenticacao > 0 && (
                    <View style={pdfStyles.statItem}>
                        <Text style={pdfStyles.statNumber}>{stats.autenticacao}</Text>
                        <Text style={pdfStyles.statLabel}>Autenticação</Text>
                    </View>
                )}
                {stats.utilizadores > 0 && (
                    <View style={pdfStyles.statItem}>
                        <Text style={pdfStyles.statNumber}>{stats.utilizadores}</Text>
                        <Text style={pdfStyles.statLabel}>Utilizadores</Text>
                    </View>
                )}
                {stats.empresas > 0 && (
                    <View style={pdfStyles.statItem}>
                        <Text style={pdfStyles.statNumber}>{stats.empresas}</Text>
                        <Text style={pdfStyles.statLabel}>Empresas</Text>
                    </View>
                )}
                {stats.clientes > 0 && (
                    <View style={pdfStyles.statItem}>
                        <Text style={pdfStyles.statNumber}>{stats.clientes}</Text>
                        <Text style={pdfStyles.statLabel}>Clientes</Text>
                    </View>
                )}
                {stats.fornecedores > 0 && (
                    <View style={pdfStyles.statItem}>
                        <Text style={pdfStyles.statNumber}>{stats.fornecedores}</Text>
                        <Text style={pdfStyles.statLabel}>Fornecedores</Text>
                    </View>
                )}
                {stats.sistema > 0 && (
                    <View style={pdfStyles.statItem}>
                        <Text style={pdfStyles.statNumber}>{stats.sistema}</Text>
                        <Text style={pdfStyles.statLabel}>Sistema</Text>
                    </View>
                )}
                {stats.outros > 0 && (
                    <View style={pdfStyles.statItem}>
                        <Text style={pdfStyles.statNumber}>{stats.outros}</Text>
                        <Text style={pdfStyles.statLabel}>Outros</Text>
                    </View>
                )}
            </View>

            {/* TABLE TITLE */}
            <Text style={pdfStyles.tableTitle}>Registos de Atividade</Text>

            {/* TABLE HEADER */}
            <View style={pdfStyles.tableHeader}>
                <Text style={[pdfStyles.tableHeaderCell, { flex: 1.1 }]}>Data/Hora</Text>
                <Text style={[pdfStyles.tableHeaderCell, { flex: 0.9 }]}>Tipo</Text>
                <Text style={[pdfStyles.tableHeaderCell, { flex: 1.4 }]}>Ação</Text>
                <Text style={[pdfStyles.tableHeaderCell, { flex: 1.2 }]}>Utilizador</Text>
                <Text style={[pdfStyles.tableHeaderCell, { flex: 1.8 }]}>Detalhes</Text>
            </View>

            {/* TABLE BODY */}
            {logs.map((log, index) => {
                const colors = tipoColors[log.tipo] || { bg: '#f1f5f9', text: '#475569', border: '#cbd5e1' };
                const isEven = index % 2 === 0;
                const icon = tipoIconSVG[log.tipo] || null;

                return (
                    <View
                        style={[
                            pdfStyles.tableRow,
                            isEven && pdfStyles.tableRowEven,
                            index === logs.length - 1 && pdfStyles.tableRowLast
                        ]}
                        key={index}
                        wrap={false}
                    >
                        <View style={pdfStyles.tableCellDate}>
                            <Text>{formatDate(log.data)}</Text>
                            <Text style={pdfStyles.relativeTime}>{getRelativeTime(log.data)}</Text>
                        </View>

                        <View style={pdfStyles.tableCellTipo}>
                            <View style={pdfStyles.iconContainer}>
                                {icon && <View>{icon}</View>}
                                <Text style={[pdfStyles.tipoBadge, {
                                    backgroundColor: colors.bg,
                                    color: colors.text,
                                    borderColor: colors.border
                                }]}>
                                    {log.tipo || 'Outros'}
                                </Text>
                            </View>
                        </View>

                        <Text style={pdfStyles.tableCellAcao}>{log.acao || '-'}</Text>

                        <View style={pdfStyles.tableCellUsuario}>
                            <Text>{log.usuarioNome || 'Sistema'}</Text>
                            {log.usuarioEmail && (
                                <Text style={pdfStyles.usuarioEmail}>{log.usuarioEmail}</Text>
                            )}
                        </View>

                        <Text style={pdfStyles.tableCellDetalhes}>
                            {log.detalhes ?
                                (log.detalhes.length > 80 ?
                                    log.detalhes.substring(0, 80) + '…' :
                                    log.detalhes
                                ) :
                                '-'
                            }
                        </Text>
                    </View>
                );
            })}

            {/* FOOTER */}
            <View style={pdfStyles.footer} fixed>
                <Text style={pdfStyles.footerText}>
                    Relatório gerado automaticamente
                </Text>
                <Text style={pdfStyles.footerText}>
                    {logs.length} registos • {new Date().toLocaleString('pt-PT', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric'
                    })}
                </Text>
            </View>
        </Page>
    </Document>
);

export default function Logs() {
    // ==============================================
    // ESTADOS
    // ==============================================
    const [logs, setLogs] = useState([]);
    const [filteredLogs, setFilteredLogs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedLog, setSelectedLog] = useState(null);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [tempToast, setTempToast] = useState(null);
    const [isSuperadmin, setIsSuperadmin] = useState(false);
    const [loggedUser, setLoggedUser] = useState(null);
    const [filters, setFilters] = useState({
        tipo: 'todos',
        dataInicio: '',
        dataFim: '',
        usuarioId: ''
    });
    const [usuariosList, setUsuariosList] = useState([]);
    const [stats, setStats] = useState({
        total: 0,
        autenticacao: 0,
        utilizadores: 0,
        empresas: 0,
        clientes: 0,
        fornecedores: 0,
        sistema: 0,
        outros: 0
    });
    const [checkingPermission, setCheckingPermission] = useState(true);

    // ==============================================
    // ESTADOS DE PAGINAÇÃO
    // ==============================================
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(9);
    const [totalPages, setTotalPages] = useState(1);

    // ==============================================
    // ESTADOS PARA O POPUP DE EXPORTAÇÃO
    // ==============================================
    const [showExportModal, setShowExportModal] = useState(false);
    const [exporting, setExporting] = useState(false);

    // ==============================================
    // ESTADOS PARA EXCLUSÃO DE LOGS
    // ==============================================
    const [deleting, setDeleting] = useState(false);
    const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
    const [deleteTarget, setDeleteTarget] = useState(null); // 'single' | 'all' | null
    const [logToDelete, setLogToDelete] = useState(null);

    // ==============================================
    // FUNÇÕES AUXILIARES
    // ==============================================
    const showTempToast = (title, message, type = 'success') => {
        setTempToast({ title, message, type });
        setTimeout(() => setTempToast(null), 3000);
    };

    const getTipoLabel = (tipo) => {
        const tipos = {
            'Autenticação': '🔐 Autenticação',
            'Utilizadores': '👥 Utilizadores',
            'Empresas': '🏢 Empresas',
            'Clientes': '👤 Clientes',
            'Fornecedores': '📦 Fornecedores',
            'Sistema': '⚙️ Sistema',
            'Licenças': '📜 Licenças',
            'Financeiro': '💰 Financeiro',
            'Vendas': '🛒 Vendas',
            'Stock': '📦 Stock',
            'Serviços': '🛠️ Serviços',
            'Lembretes': '⏰ Lembretes',
            'Arquivo': '📁 Arquivo',
            'Eliminação': '🗑️ Eliminação',
            'Entrada de Stock': '📥 Entrada de Stock',
            'Inventario': '📊 Inventário',
            'Criar Produtos': '➕ Criar Produtos',
            'Categorias': '🏷️ Categorias',
            'Listar Produtos': '📋 Listar Produtos',
            'Movimentos': '🔄 Movimentos',
            'Armazéns': '🏭 Armazéns',
            'Cotações': '📝 Cotações',
            'Recebimentos': '💵 Recebimentos',
            'Transferências': '🔀 Transferências',
            'Logs': '📋 Logs'
        };
        return tipos[tipo] || tipo;
    };

    const getTipoIcon = (tipo) => {
        const icons = {
            'Autenticação': '🔐',
            'Utilizadores': '👥',
            'Empresas': '🏢',
            'Clientes': '👤',
            'Fornecedores': '📦',
            'Sistema': '⚙️',
            'Licenças': '📜',
            'Financeiro': '💰',
            'Vendas': '🛒',
            'Stock': '📦',
            'Serviços': '🛠️',
            'Lembretes': '⏰',
            'Arquivo': '📁',
            'Eliminação': '🗑️',
            'Entrada de Stock': '📥',
            'Inventario': '📊',
            'Criar Produtos': '➕',
            'Categorias': '🏷️',
            'Listar Produtos': '📋',
            'Movimentos': '🔄',
            'Armazéns': '🏭',
            'Cotações': '📝',
            'Recebimentos': '💵',
            'Transferências': '🔀',
            'Logs': '📋'
        };
        return icons[tipo] || '📋';
    };

    const getTipoColor = (tipo) => {
        const colors = {
            'Autenticação': '#5c6bc0',
            'Utilizadores': '#2ecc71',
            'Empresas': '#f39c12',
            'Clientes': '#3498db',
            'Fornecedores': '#d97706',
            'Sistema': '#e74c3c',
            'Licenças': '#9b59b6',
            'Financeiro': '#2ecc71',
            'Vendas': '#3498db',
            'Stock': '#f39c12',
            'Serviços': '#16a34a',
            'Lembretes': '#e74c3c',
            'Arquivo': '#6b7280',
            'Eliminação': '#dc2626',
            'Entrada de Stock': '#059669',
            'Inventario': '#0ea5e9',
            'Criar Produtos': '#8b5cf6',
            'Categorias': '#a855f7',
            'Listar Produtos': '#06b6d4',
            'Movimentos': '#f59e0b',
            'Armazéns': '#78350f',
            'Cotações': '#ec4899',
            'Recebimentos': '#10b981',
            'Transferências': '#6366f1',
            'Logs': '#475569'
        };
        return colors[tipo] || '#6b7280';
    };

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toLocaleString('pt-PT', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const formatDateShort = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toLocaleString('pt-PT', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    const getRelativeTime = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const now = new Date();
        const diff = now - date;
        const minutes = Math.floor(diff / 60000);
        const hours = Math.floor(diff / 3600000);
        const days = Math.floor(diff / 86400000);

        if (minutes < 1) return 'Agora mesmo';
        if (minutes < 60) return `${minutes} min atrás`;
        if (hours < 24) return `${hours} h atrás`;
        if (days < 30) return `${days} dias atrás`;
        if (days < 365) return `${Math.floor(days / 30)} meses atrás`;
        return `${Math.floor(days / 365)} anos atrás`;
    };

    // ==============================================
    // FUNÇÃO PARA OBTER DESCRIÇÃO DO FILTRO
    // ==============================================
    const getFiltroDescricao = () => {
        let descricao = '';

        if (filters.tipo !== 'todos') {
            descricao = `Tipo: ${filters.tipo}`;
        }

        if (filters.usuarioId && isSuperadmin) {
            const usuario = usuariosList.find(u => u._id === filters.usuarioId);
            if (usuario) {
                descricao += descricao ? `, Utilizador: ${usuario.nome}` : `Utilizador: ${usuario.nome}`;
            }
        }

        if (filters.dataInicio && filters.dataFim) {
            const inicio = new Date(filters.dataInicio).toLocaleDateString('pt-PT');
            const fim = new Date(filters.dataFim).toLocaleDateString('pt-PT');
            descricao += descricao ? `, Período: ${inicio} - ${fim}` : `Período: ${inicio} - ${fim}`;
        } else if (filters.dataInicio) {
            const inicio = new Date(filters.dataInicio).toLocaleDateString('pt-PT');
            descricao += descricao ? `, Desde: ${inicio}` : `Desde: ${inicio}`;
        } else if (filters.dataFim) {
            const fim = new Date(filters.dataFim).toLocaleDateString('pt-PT');
            descricao += descricao ? `, Até: ${fim}` : `Até: ${fim}`;
        }

        if (searchTerm.trim()) {
            descricao += descricao ? `, Pesquisa: "${searchTerm}"` : `Pesquisa: "${searchTerm}"`;
        }

        return descricao || 'Todos os logs';
    };

    // ==============================================
    // OBTER LOGS DA PÁGINA ATUAL
    // ==============================================
    const getCurrentPageLogs = () => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        return filteredLogs.slice(startIndex, endIndex);
    };

    // ==============================================
    // MUDAR DE PÁGINA
    // ==============================================
    const goToPage = (page) => {
        if (page < 1 || page > totalPages) return;
        setCurrentPage(page);
        const tableWrapper = document.querySelector('.logs-table-wrapper');
        if (tableWrapper) {
            tableWrapper.scrollTop = 0;
        }
    };

    const goToPreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
            const tableWrapper = document.querySelector('.logs-table-wrapper');
            if (tableWrapper) tableWrapper.scrollTop = 0;
        }
    };

    const goToNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
            const tableWrapper = document.querySelector('.logs-table-wrapper');
            if (tableWrapper) tableWrapper.scrollTop = 0;
        }
    };

    // ==============================================
    // ATUALIZAR TOTAL DE PÁGINAS
    // ==============================================
    useEffect(() => {
        const total = Math.ceil(filteredLogs.length / itemsPerPage);
        setTotalPages(total > 0 ? total : 1);
        if (currentPage > total && total > 0) {
            setCurrentPage(1);
        }
    }, [filteredLogs, itemsPerPage]);

    // ==============================================
    // BUSCAR DADOS
    // ==============================================
    const fetchLogs = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                setLoading(false);
                return;
            }

            console.log('📊 Buscando logs...');
            const response = await axios.get('/api/logs', {
                headers: { Authorization: `Bearer ${token}` }
            });

            console.log('📊 Resposta dos logs:', response.data);

            if (response.data) {
                const logsData = response.data.data || response.data;
                const sortedLogs = logsData.sort((a, b) => {
                    return new Date(b.data) - new Date(a.data);
                });
                setLogs(sortedLogs);
                setFilteredLogs(sortedLogs);
                calcularStats(sortedLogs);
                setCurrentPage(1);
            }
        } catch (err) {
            console.error('❌ Erro ao buscar logs:', err);
            if (err.response?.status === 403) {
                showTempToast('Acesso Negado', 'Não tem permissão para visualizar os logs', 'danger');
            } else if (err.response?.status === 404) {
                showTempToast('Info', 'Nenhum log encontrado no sistema', 'warning');
            } else {
                showTempToast('Erro', 'Não foi possível carregar os logs', 'danger');
            }
        } finally {
            setLoading(false);
        }
    };

    const fetchLoggedUser = async () => {
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                setCheckingPermission(false);
                return null;
            }

            console.log('👤 Buscando utilizador logado...');
            const response = await axios.get('/api/users/me', {
                headers: { Authorization: `Bearer ${token}` }
            });

            console.log('👤 Resposta do usuário:', response.data);

            if (response.data && response.data.success) {
                const userData = response.data.data;
                setLoggedUser(userData);
                setIsSuperadmin(userData.perfil === 'Superadmin');
                console.log('👤 Utilizador logado:', userData.nome, 'Perfil:', userData.perfil);
                return userData;
            } else if (response.data) {
                const userData = response.data.data || response.data;
                setLoggedUser(userData);
                setIsSuperadmin(userData.perfil === 'Superadmin');
                console.log('👤 Utilizador logado (fallback):', userData.nome, 'Perfil:', userData.perfil);
                return userData;
            }
        } catch (err) {
            console.error('❌ Erro ao buscar utilizador logado:', err);
            try {
                const usuarioSalvo = JSON.parse(localStorage.getItem('usuario') || '{}');
                if (usuarioSalvo && usuarioSalvo.perfil) {
                    setLoggedUser(usuarioSalvo);
                    setIsSuperadmin(usuarioSalvo.perfil === 'Superadmin');
                    console.log('👤 Utilizador do localStorage:', usuarioSalvo.nome, 'Perfil:', usuarioSalvo.perfil);
                    return usuarioSalvo;
                }
            } catch (e) {
                console.error('❌ Erro ao buscar do localStorage:', e);
            }
        } finally {
            setCheckingPermission(false);
        }
        return null;
    };

    const fetchUsuarios = async () => {
        try {
            const token = localStorage.getItem('token');
            if (!token) return;

            const response = await axios.get('/api/users', {
                headers: { Authorization: `Bearer ${token}` }
            });

            if (response.data) {
                const users = response.data.data || response.data;
                setUsuariosList(users);
            }
        } catch (err) {
            console.error('❌ Erro ao buscar utilizadores:', err);
        }
    };

    // ==============================================
    // CALCULAR ESTATÍSTICAS
    // ==============================================
    const calcularStats = (logsData) => {
        const stats = {
            total: logsData.length,
            autenticacao: 0,
            utilizadores: 0,
            empresas: 0,
            clientes: 0,
            fornecedores: 0,
            sistema: 0,
            outros: 0
        };

        logsData.forEach(log => {
            const tipo = log.tipo || 'Outros';
            if (tipo.includes('Autenticação') || tipo === 'Autenticação') {
                stats.autenticacao++;
            } else if (tipo.includes('Utilizadores') || tipo === 'Utilizadores') {
                stats.utilizadores++;
            } else if (tipo.includes('Empresas') || tipo === 'Empresas') {
                stats.empresas++;
            } else if (tipo.includes('Clientes') || tipo === 'Clientes') {
                stats.clientes++;
            } else if (tipo.includes('Fornecedores') || tipo === 'Fornecedores') {
                stats.fornecedores++;
            } else if (tipo.includes('Sistema') || tipo === 'Sistema') {
                stats.sistema++;
            } else {
                stats.outros++;
            }
        });

        setStats(stats);
    };

    // ==============================================
    // FILTRAR LOGS
    // ==============================================
    useEffect(() => {
        let filtered = [...logs];

        if (searchTerm.trim()) {
            const term = searchTerm.toLowerCase().trim();
            filtered = filtered.filter(log =>
                (log.acao || '').toLowerCase().includes(term) ||
                (log.detalhes || '').toLowerCase().includes(term) ||
                (log.tipo || '').toLowerCase().includes(term) ||
                (log.usuarioNome || '').toLowerCase().includes(term) ||
                (log.usuarioEmail || '').toLowerCase().includes(term)
            );
        }

        if (filters.tipo !== 'todos') {
            filtered = filtered.filter(log => log.tipo === filters.tipo);
        }

        if (filters.dataInicio) {
            const inicio = new Date(filters.dataInicio);
            inicio.setHours(0, 0, 0, 0);
            filtered = filtered.filter(log => {
                const dataLog = new Date(log.data);
                return dataLog >= inicio;
            });
        }

        if (filters.dataFim) {
            const fim = new Date(filters.dataFim);
            fim.setHours(23, 59, 59, 999);
            filtered = filtered.filter(log => {
                const dataLog = new Date(log.data);
                return dataLog <= fim;
            });
        }

        if (filters.usuarioId) {
            filtered = filtered.filter(log => log.usuarioId === filters.usuarioId);
        }

        setFilteredLogs(filtered);
        setCurrentPage(1);
    }, [searchTerm, filters, logs]);

    // ==============================================
    // CARREGAR DADOS INICIAIS
    // ==============================================
    useEffect(() => {
        const carregarDados = async () => {
            setCheckingPermission(true);
            const user = await fetchLoggedUser();

            const perfil = user?.perfil || loggedUser?.perfil;
            const podeVer = perfil === 'Superadmin' || perfil === 'Admin';

            console.log('🔍 Verificando permissão:', { perfil, podeVer });

            if (podeVer) {
                console.log('✅ Utilizador tem permissão para ver logs');
                await fetchUsuarios();
                await fetchLogs();
            } else {
                console.log('❌ Utilizador NÃO tem permissão para ver logs');
                if (perfil) {
                    showTempToast('Acesso Negado', `Perfil "${perfil}" não tem permissão para visualizar logs`, 'danger');
                }
                setCheckingPermission(false);
            }
        };
        carregarDados();
    }, []);

    // ==============================================
    // ABRIR DETALHES DO LOG
    // ==============================================
    const openLogDetails = (log) => {
        setSelectedLog(log);
        setShowDetailsModal(true);
    };

    const closeDetailsModal = () => {
        setShowDetailsModal(false);
        setSelectedLog(null);
    };

    // ==============================================
    // LIMPAR FILTROS
    // ==============================================
    const clearFilters = () => {
        setFilters({
            tipo: 'todos',
            dataInicio: '',
            dataFim: '',
            usuarioId: ''
        });
        setSearchTerm('');
        setCurrentPage(1);
    };

    // ==============================================
    // EXCLUIR LOGS
    // ==============================================
    const openDeleteSingleConfirm = (log) => {
        setLogToDelete(log);
        setDeleteTarget('single');
        setShowDeleteConfirmModal(true);
    };

    const openDeleteAllConfirm = () => {
        setDeleteTarget('all');
        setShowDeleteConfirmModal(true);
    };

    const closeDeleteConfirmModal = () => {
        setShowDeleteConfirmModal(false);
        setLogToDelete(null);
        setDeleteTarget(null);
    };

    const confirmDelete = async () => {
        setDeleting(true);
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                showTempToast('Erro', 'Sessão expirada', 'danger');
                closeDeleteConfirmModal();
                setDeleting(false);
                return;
            }

            let deletedCount = 0;

            if (deleteTarget === 'single' && logToDelete) {
                const logId = logToDelete._id || logToDelete.id;
                if (!logId) {
                    showTempToast('Erro', 'ID do log não encontrado', 'danger');
                    closeDeleteConfirmModal();
                    setDeleting(false);
                    return;
                }

                await axios.delete(`/api/logs/${logId}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                deletedCount = 1;

                showTempToast('Sucesso', `Log de "${logToDelete.acao || 'atividade'}" removido com sucesso!`, 'success');
            } else if (deleteTarget === 'all') {
                const logsToDelete = filteredLogs;

                if (logsToDelete.length === 0) {
                    showTempToast('Aviso', 'Não há logs para excluir', 'warning');
                    closeDeleteConfirmModal();
                    setDeleting(false);
                    return;
                }

                const logIds = logsToDelete.map(log => log._id || log.id).filter(id => id);
                if (logIds.length === 0) {
                    showTempToast('Erro', 'IDs dos logs não encontrados', 'danger');
                    closeDeleteConfirmModal();
                    setDeleting(false);
                    return;
                }

                const response = await axios.delete('/api/logs/bulk', {
                    headers: { Authorization: `Bearer ${token}` },
                    data: { ids: logIds }
                });

                deletedCount = response.data?.deletedCount || logIds.length;

                showTempToast(
                    'Sucesso',
                    `${deletedCount} log(s) removido(s) com sucesso!`,
                    'success'
                );
            }

            await fetchLogs();
            closeDeleteConfirmModal();

        } catch (err) {
            console.error('❌ Erro ao excluir log(s):', err);
            showTempToast(
                'Erro',
                err.response?.data?.erro || 'Não foi possível excluir os logs',
                'danger'
            );
        } finally {
            setDeleting(false);
        }
    };

    // ==============================================
    // EXPORTAR LOGS - CSV
    // ==============================================
    const exportCSV = () => {
        if (filteredLogs.length === 0) {
            showTempToast('Aviso', 'Não há logs para exportar', 'warning');
            return;
        }

        setExporting(true);
        try {
            const headers = [
                'Data/Hora',
                'Tipo',
                'Ação',
                'Utilizador',
                'Email',
                'Detalhes',
                'ID do Utilizador'
            ];

            const rows = filteredLogs.map(log => [
                formatDate(log.data),
                log.tipo || 'Outros',
                `"${(log.acao || '').replace(/"/g, '""')}"`,
                `"${(log.usuarioNome || 'Sistema').replace(/"/g, '""')}"`,
                log.usuarioEmail || '',
                `"${(log.detalhes || '').replace(/"/g, '""')}"`,
                log.usuarioId || ''
            ]);

            const csvContent = [
                headers.join(';'),
                ...rows.map(row => row.join(';'))
            ].join('\n');

            const blob = new Blob(['\uFEFF' + csvContent], {
                type: 'text/csv;charset=utf-8;'
            });

            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `logs_${new Date().toISOString().slice(0, 10)}.csv`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(link.href);

            showTempToast('Sucesso', `Logs exportados em CSV com sucesso! (${filteredLogs.length} registos)`, 'success');
            setShowExportModal(false);
        } catch (err) {
            console.error('❌ Erro ao exportar logs CSV:', err);
            showTempToast('Erro', 'Não foi possível exportar os logs', 'danger');
        } finally {
            setExporting(false);
        }
    };

    // ==============================================
    // EXPORTAR LOGS - PDF
    // ==============================================
    const exportPDF = async () => {
        if (filteredLogs.length === 0) {
            showTempToast('Aviso', 'Não há logs para exportar', 'warning');
            return;
        }

        setExporting(true);
        try {
            const { pdf } = await import('@react-pdf/renderer');

            const filtroDescricao = getFiltroDescricao();

            const doc = (
                <LogsPDFDocument
                    logs={filteredLogs}
                    stats={stats}
                    formatDate={formatDate}
                    getRelativeTime={getRelativeTime}
                    filtroDescricao={filtroDescricao}
                />
            );

            const blob = await pdf(doc).toBlob();

            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `logs_${new Date().toISOString().slice(0, 10)}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);

            showTempToast('Sucesso', 'Logs exportados em PDF com sucesso!', 'success');
            setShowExportModal(false);
        } catch (err) {
            console.error('❌ Erro ao exportar logs PDF:', err);
            showTempToast('Erro', 'Não foi possível exportar os logs: ' + err.message, 'danger');
        } finally {
            setExporting(false);
        }
    };

    // ==============================================
    // ABRIR MODAL DE EXPORTAÇÃO
    // ==============================================
    const openExportModal = () => {
        if (filteredLogs.length === 0) {
            showTempToast('Aviso', 'Não há logs para exportar', 'warning');
            return;
        }
        setShowExportModal(true);
    };

    const closeExportModal = () => {
        setShowExportModal(false);
    };

    // ==============================================
    // RENDER TOAST
    // ==============================================
    const renderToast = () => {
        if (!tempToast) return null;
        return (
            <div className={`logs-toast ${tempToast.type}`}>
                <div className="toast-icon">
                    <Icon name={tempToast.type === 'success' ? 'add' : 'close'} size={20} />
                </div>
                <div className="toast-content">
                    <div className="toast-title">{tempToast.title}</div>
                    <div className="toast-message">{tempToast.message}</div>
                </div>
                <button className="toast-close" onClick={() => setTempToast(null)}>×</button>
            </div>
        );
    };

    // ==============================================
    // RENDER MODAL DE DETALHES
    // ==============================================
    const renderDetailsModal = () => {
        if (!showDetailsModal || !selectedLog) return null;

        return (
            <div className="logs-modal-overlay" onClick={closeDetailsModal}>
                <div className="logs-modal" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-header">
                        <h3>📋 Detalhes do Log</h3>
                        <button className="modal-close" onClick={closeDetailsModal}>×</button>
                    </div>
                    <div className="modal-body">
                        <div className="log-details">
                            <div className="detail-row">
                                <span className="detail-label"> Data:</span>
                                <span className="detail-value">{formatDate(selectedLog.data)}</span>
                            </div>
                            <div className="detail-row">
                                <span className="detail-label"> Relativo:</span>
                                <span className="detail-value">{getRelativeTime(selectedLog.data)}</span>
                            </div>
                            <div className="detail-row">
                                <span className="detail-label"> Tipo:</span>
                                <span className="detail-value" style={{ color: getTipoColor(selectedLog.tipo) }}>
                                    {getTipoIcon(selectedLog.tipo)} {selectedLog.tipo || 'Outros'}
                                </span>
                            </div>
                            <div className="detail-row">
                                <span className="detail-label"> Ação:</span>
                                <span className="detail-value">{selectedLog.acao || '-'}</span>
                            </div>
                            <div className="detail-row">
                                <span className="detail-label"> Utilizador:</span>
                                <span className="detail-value">{selectedLog.usuarioNome || 'Sistema'}</span>
                            </div>
                            {selectedLog.usuarioEmail && (
                                <div className="detail-row">
                                    <span className="detail-label"> Email:</span>
                                    <span className="detail-value">{selectedLog.usuarioEmail}</span>
                                </div>
                            )}
                            {selectedLog.usuarioId && (
                                <div className="detail-row">
                                    <span className="detail-label"> ID:</span>
                                    <span className="detail-value" style={{ fontSize: '0.7rem', fontFamily: 'monospace' }}>{selectedLog.usuarioId}</span>
                                </div>
                            )}
                            {selectedLog.detalhes && (
                                <div className="detail-row" style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                                    <span className="detail-label"> Detalhes:</span>
                                    <span className="detail-value" style={{ textAlign: 'left', width: '100%', marginTop: '0.3rem', padding: '0.5rem', background: 'var(--color-light)', borderRadius: '8px', fontSize: '0.75rem' }}>
                                        {selectedLog.detalhes}
                                    </span>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button className="btn-close" onClick={closeDetailsModal}>Fechar</button>
                    </div>
                </div>
            </div>
        );
    };

    // ==============================================
    // RENDER MODAL DE EXPORTAÇÃO
    // ==============================================
    const renderExportModal = () => {
        if (!showExportModal) return null;

        return (
            <div className="logs-modal-overlay" onClick={closeExportModal}>
                <div className="logs-modal export-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '420px' }}>
                    <div className="modal-header">
                        <h3>📤 Exportar Logs</h3>
                        <button className="modal-close" onClick={closeExportModal}>×</button>
                    </div>
                    <div className="modal-body" style={{ textAlign: 'center', padding: '1.5rem 1.5rem 1rem' }}>
                        <div style={{ fontSize: '3rem', marginBottom: '0.5rem' }}>📊</div>
                        <h4 style={{ margin: '0 0 0.3rem 0', fontSize: '1.1rem', fontWeight: '600', color: 'var(--color-dark)' }}>
                            Escolha o formato de exportação
                        </h4>
                        <p style={{ color: 'var(--color-info-dark)', fontSize: '0.85rem', margin: '0 0 1.2rem 0' }}>
                            {filteredLogs.length} registos serão exportados
                        </p>

                        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
                            <button
                                className="export-option-btn csv"
                                onClick={exportCSV}
                                disabled={exporting}
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: '0.5rem',
                                    padding: '1.2rem 1.8rem',
                                    background: 'var(--color-white)',
                                    border: '2px solid var(--color-border)',
                                    borderRadius: '16px',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                    minWidth: '120px',
                                    fontFamily: 'inherit',
                                    opacity: exporting ? 0.6 : 1,
                                    pointerEvents: exporting ? 'none' : 'auto'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.borderColor = '#2ecc71';
                                    e.currentTarget.style.boxShadow = '0 4px 20px rgba(46, 204, 113, 0.2)';
                                    e.currentTarget.style.transform = 'translateY(-4px)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.borderColor = 'var(--color-border)';
                                    e.currentTarget.style.boxShadow = 'none';
                                    e.currentTarget.style.transform = 'translateY(0)';
                                }}
                            >
                                <span style={{ fontSize: '2rem' }}>📄</span>
                                <span style={{ fontWeight: '600', fontSize: '0.9rem', color: 'var(--color-dark)' }}>CSV</span>
                                <span style={{ fontSize: '0.65rem', color: 'var(--color-info-dark)' }}>Excel / Planilhas</span>
                            </button>

                            <button
                                className="export-option-btn pdf"
                                onClick={exportPDF}
                                disabled={exporting}
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: '0.5rem',
                                    padding: '1.2rem 1.8rem',
                                    background: 'var(--color-white)',
                                    border: '2px solid var(--color-border)',
                                    borderRadius: '16px',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                    minWidth: '120px',
                                    fontFamily: 'inherit',
                                    opacity: exporting ? 0.6 : 1,
                                    pointerEvents: exporting ? 'none' : 'auto'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.borderColor = '#e74c3c';
                                    e.currentTarget.style.boxShadow = '0 4px 20px rgba(231, 76, 60, 0.2)';
                                    e.currentTarget.style.transform = 'translateY(-4px)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.borderColor = 'var(--color-border)';
                                    e.currentTarget.style.boxShadow = 'none';
                                    e.currentTarget.style.transform = 'translateY(0)';
                                }}
                            >
                                <span style={{ fontSize: '2rem' }}>📕</span>
                                <span style={{ fontWeight: '600', fontSize: '0.9rem', color: 'var(--color-dark)' }}>PDF</span>
                                <span style={{ fontSize: '0.65rem', color: 'var(--color-info-dark)' }}>Relatório formatado</span>
                            </button>
                        </div>

                        {exporting && (
                            <div style={{ marginTop: '1rem', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}>
                                <div className="spinner-small"></div>
                                <span style={{ fontSize: '0.8rem', color: 'var(--color-info-dark)' }}>A gerar ficheiro...</span>
                            </div>
                        )}
                    </div>
                    <div className="modal-footer" style={{ justifyContent: 'center' }}>
                        <button className="btn-close" onClick={closeExportModal} disabled={exporting}>
                            Cancelar
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    // ==============================================
    // RENDER MODAL DE CONFIRMAÇÃO DE EXCLUSÃO
    // ==============================================
    const renderDeleteConfirmModal = () => {
        if (!showDeleteConfirmModal) return null;

        const isAll = deleteTarget === 'all';
        const count = filteredLogs.length;
        const logName = logToDelete?.acao || 'atividade';

        return (
            <div className="logs-modal-overlay" onClick={closeDeleteConfirmModal}>
                <div className="logs-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '440px' }}>
                    <div className="modal-header" style={{ borderBottomColor: '#e74c3c' }}>
                        <h3 style={{ color: '#e74c3c' }}>
                            {isAll ? '🗑️ Apagar Todos os Logs' : '🗑️ Apagar Log'}
                        </h3>
                        <button className="modal-close" onClick={closeDeleteConfirmModal}>×</button>
                    </div>
                    <div className="modal-body" style={{ textAlign: 'center', padding: '1.5rem' }}>
                        <div style={{ fontSize: '3rem', marginBottom: '0.5rem' }}>
                            {isAll ? '⚠️' : '🗑️'}
                        </div>
                        <h4 style={{ margin: '0 0 0.5rem 0', fontSize: '1rem', color: 'var(--color-dark)' }}>
                            {isAll
                                ? `Tem certeza que deseja apagar todos os ${count} log(s) visíveis?`
                                : `Tem certeza que deseja apagar este log?`
                            }
                        </h4>
                        {isAll ? (
                            <p style={{ color: 'var(--color-info-dark)', fontSize: '0.85rem', margin: '0' }}>
                                Esta ação irá remover permanentemente <strong>{count}</strong> registo(s) da base de dados.
                                {count > 0 && ' Esta ação é irreversível!'}
                            </p>
                        ) : (
                            <p style={{ color: 'var(--color-info-dark)', fontSize: '0.85rem', margin: '0' }}>
                                Log: <strong>"{logName}"</strong><br />
                                Data: {logToDelete ? formatDate(logToDelete.data) : '-'}
                            </p>
                        )}
                        <p style={{ color: '#e74c3c', fontSize: '0.75rem', marginTop: '0.5rem' }}>
                            ⚠️ Esta ação não pode ser desfeita!
                        </p>
                    </div>
                    <div className="modal-footer" style={{ justifyContent: 'center', gap: '0.8rem' }}>
                        <button
                            className="btn-close"
                            onClick={closeDeleteConfirmModal}
                            disabled={deleting}
                            style={{
                                background: 'transparent',
                                color: 'var(--color-dark)',
                                boxShadow: 'none',
                                height: '40px !important',
                                border: '1px solid var(--color-border)'
                            }}
                        >
                            Cancelar
                        </button>
                        <button
                            className="btn-close"
                            onClick={confirmDelete}
                            disabled={deleting}
                            style={{
                                background: 'linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)',
                                color: 'white',
                                border: 'none',
                                height: '40px !important',
                                boxShadow: '0 4px 20px rgba(231, 76, 60, 0.3)'
                            }}
                        >
                            {deleting ? (
                                <>
                                    <span className="spinner-small" style={{ marginRight: '0.5rem' }}></span>
                                    A apagar...
                                </>
                            ) : (
                                isAll ? `Apagar ${count} logs` : 'Apagar Log'
                            )}
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    // ==============================================
    // RENDER PAGINAÇÃO
    // ==============================================
    const renderPagination = () => {
        if (totalPages <= 1) return null;

        const currentLogs = getCurrentPageLogs();
        const startItem = (currentPage - 1) * itemsPerPage + 1;
        const endItem = Math.min(currentPage * itemsPerPage, filteredLogs.length);

        return (
            <div className="logs-pagination">
                <div className="pagination-info">
                    <span>
                        Mostrando {startItem} - {endItem} de {filteredLogs.length} registos
                    </span>
                </div>
                <div className="pagination-controls">
                    <button
                        className="pagination-btn"
                        onClick={goToPreviousPage}
                        disabled={currentPage === 1}
                        title="Página anterior"
                    >
                        <Icon name="chevron_left" size={18} />
                    </button>

                    <div className="pagination-numbers">
                        {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => {
                            if (
                                page === 1 ||
                                page === totalPages ||
                                (page >= currentPage - 2 && page <= currentPage + 2)
                            ) {
                                return (
                                    <button
                                        key={page}
                                        className={`pagination-number ${currentPage === page ? 'active' : ''}`}
                                        onClick={() => goToPage(page)}
                                    >
                                        {page}
                                    </button>
                                );
                            }
                            if (
                                (page === currentPage - 3 && page > 2) ||
                                (page === currentPage + 3 && page < totalPages - 1)
                            ) {
                                return <span key={page} className="pagination-ellipsis">…</span>;
                            }
                            return null;
                        })}
                    </div>

                    <button
                        className="pagination-btn"
                        onClick={goToNextPage}
                        disabled={currentPage === totalPages}
                        title="Próxima página"
                    >
                        <Icon name="chevron_right" size={18} />
                    </button>
                </div>
            </div>
        );
    };

    // ==============================================
    // RENDER PRINCIPAL
    // ==============================================
    const perfil = loggedUser?.perfil;
    const podeVerLogs = perfil === 'Superadmin' || perfil === 'Admin';

    const currentPageLogs = getCurrentPageLogs();

    if (checkingPermission) {
        return (
            <div className="logs-container">
                <div className="logs-header">
                    <div className="header-title">
                        <h1>📋 Logs do Sistema</h1>
                        <p>Registo de atividades do sistema</p>
                    </div>
                </div>
                <div className="loading-state">
                    <div className="spinner"></div>
                    <p>A verificar permissões...</p>
                </div>
            </div>
        );
    }

    if (!podeVerLogs) {
        return (
            <div className="logs-container">
                <div className="logs-header">
                    <div className="header-title">
                        <h1>📋 Logs do Sistema</h1>
                        <p>Registo de atividades do sistema</p>
                    </div>
                </div>
                <div className="logs-access-denied">
                    <Icon name="lock" size={64} color="var(--color-danger)" />
                    <h2>Acesso Negado</h2>
                    <p>Não tem permissão para visualizar os logs do sistema.</p>
                    <p style={{ fontSize: '0.85rem', color: 'var(--color-info-dark)' }}>
                        Apenas Administradores e Superadmins podem aceder a esta área.
                    </p>
                    {perfil && (
                        <p style={{ fontSize: '0.75rem', color: 'var(--color-info-dark)', marginTop: '0.5rem' }}>
                            Seu perfil atual: <strong>{perfil}</strong>
                        </p>
                    )}
                </div>
            </div>
        );
    }

    return (
        <div className="logs-container">
            {/* HEADER */}
            <div className="logs-header">
                <div className="header-title">
                    <h1>📋 Logs do Sistema</h1>
                    <p>Registo de atividades do sistema</p>
                </div>
                <div className="header-actions">
                    <button className="btn-export" onClick={openExportModal}>
                        <Icon name="file_download" size={20} /> Exportar
                    </button>
                    {filteredLogs.length > 0 && (
                        <button
                            className="btn-delete-all"
                            onClick={openDeleteAllConfirm}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.4rem',
                                padding: '0.5rem 1.2rem',
                                background: 'linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)',
                                color: 'white',
                                border: 'none',
                                borderRadius: '100px',
                                fontWeight: '600',
                                cursor: 'pointer',
                                transition: 'all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                                fontFamily: 'Poppins, sans-serif',
                                fontSize: '0.75rem',
                                boxShadow: '0 4px 20px rgba(231, 76, 60, 0.25)',
                                position: 'relative',
                                overflow: 'hidden'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-3px) scale(1.02)';
                                e.currentTarget.style.boxShadow = '0 8px 32px rgba(231, 76, 60, 0.4)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0) scale(1)';
                                e.currentTarget.style.boxShadow = '0 4px 20px rgba(231, 76, 60, 0.25)';
                            }}
                        >
                            <Icon name="delete" size={18} /> Apagar Logs ({filteredLogs.length})
                        </button>
                    )}
                </div>
            </div>

            {/* STATS */}
            <div className="logs-stats">
                <div className="stat-card">
                    <div className="stat-number">{stats.total}</div>
                    <div className="stat-label">TOTAL</div>
                </div>
                <div className="stat-card primary">
                    <div className="stat-number">{stats.autenticacao}</div>
                    <div className="stat-label"> Autenticação</div>
                </div>
                <div className="stat-card success">
                    <div className="stat-number">{stats.utilizadores}</div>
                    <div className="stat-label"> Utilizadores</div>
                </div>
                <div className="stat-card warning">
                    <div className="stat-number">{stats.empresas}</div>
                    <div className="stat-label"> Empresas</div>
                </div>
                <div className="stat-card danger">
                    <div className="stat-number">{stats.sistema}</div>
                    <div className="stat-label"> Sistema</div>
                </div>
                <div className="stat-card info">
                    <div className="stat-number">{stats.outros}</div>
                    <div className="stat-label"> Outros</div>
                </div>
            </div>

            {/* FILTROS E PESQUISA */}
            <div className="logs-filters">
                <div className="search-wrapper">
                    <Icon name="search" size={20} color="var(--color-info-dark)" />
                    <input
                        type="text"
                        placeholder="Pesquisar logs..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    {searchTerm && (
                        <button className="clear-search" onClick={() => setSearchTerm('')}>×</button>
                    )}
                </div>

                <div className="filters-row">
                    <select
                        value={filters.tipo}
                        onChange={(e) => setFilters({ ...filters, tipo: e.target.value })}
                    >
                        <option value="todos">Todos os Tipos</option>
                        <option value="Autenticação">🔐 Autenticação</option>
                        <option value="Utilizadores">👥 Utilizadores</option>
                        <option value="Empresas">🏢 Empresas</option>
                        <option value="Clientes">👤 Clientes</option>
                        <option value="Fornecedores">📦 Fornecedores</option>
                        <option value="Sistema">⚙️ Sistema</option>
                        <option value="Licenças">📜 Licenças</option>
                        <option value="Financeiro">💰 Financeiro</option>
                        <option value="Vendas">🛒 Vendas</option>
                        <option value="Stock">📦 Stock</option>
                        <option value="Serviços">🛠️ Serviços</option>
                        <option value="Lembretes">⏰ Lembretes</option>
                        <option value="Arquivo">📁 Arquivo</option>
                        <option value="Eliminação">🗑️ Eliminação</option>
                        <option value="Entrada de Stock">📥 Entrada de Stock</option>
                        <option value="Inventario">📊 Inventário</option>
                        <option value="Criar Produtos">➕ Criar Produtos</option>
                        <option value="Categorias">🏷️ Categorias</option>
                        <option value="Listar Produtos">📋 Listar Produtos</option>
                        <option value="Movimentos">🔄 Movimentos</option>
                        <option value="Armazéns">🏭 Armazéns</option>
                        <option value="Cotações">📝 Cotações</option>
                        <option value="Recebimentos">💵 Recebimentos</option>
                        <option value="Transferências">🔀 Transferências</option>
                        <option value="Logs">📋 Logs</option>
                        <option value="Outros">📋 Outros</option>
                    </select>

                    <input
                        type="date"
                        value={filters.dataInicio}
                        onChange={(e) => setFilters({ ...filters, dataInicio: e.target.value })}
                        title="Data de início"
                    />

                    <input
                        type="date"
                        value={filters.dataFim}
                        onChange={(e) => setFilters({ ...filters, dataFim: e.target.value })}
                        title="Data de fim"
                    />

                    {isSuperadmin && (
                        <select
                            value={filters.usuarioId}
                            onChange={(e) => setFilters({ ...filters, usuarioId: e.target.value })}
                        >
                            <option value="">Todos os Utilizadores</option>
                            {usuariosList.map(user => (
                                <option key={user._id} value={user._id}>
                                    {user.nome} ({user.email})
                                </option>
                            ))}
                        </select>
                    )}

                    <button className="btn-clear-filters" onClick={clearFilters}>
                        <Icon name="clear" size={16} /> Limpar
                    </button>
                </div>

                <div className="filters-info">
                    <span>{filteredLogs.length} registos encontrados</span>
                    {filteredLogs.length !== logs.length && (
                        <span className="filter-active">🔍 Filtro ativo</span>
                    )}
                </div>
            </div>

            {/* TABLE */}
            <div className="logs-table-wrapper">
                {loading ? (
                    <div className="loading-state">
                        <div className="spinner"></div>
                        <p>A carregar logs...</p>
                    </div>
                ) : filteredLogs.length === 0 ? (
                    <div className="empty-state">
                        <Icon name="history" size={48} color="var(--color-info-dark)" />
                        <h3>Nenhum log encontrado</h3>
                        <p>{searchTerm || filters.tipo !== 'todos' ? 'Tente ajustar os filtros de pesquisa' : 'Ainda não há registos de atividade'}</p>
                    </div>
                ) : (
                    <>
                        <table className="logs-table">
                            <thead>
                                <tr>
                                    <th>DATA/HORA</th>
                                    <th>TIPO</th>
                                    <th>AÇÃO</th>
                                    <th>UTILIZADOR</th>
                                    <th>DETALHES</th>
                                    <th>AÇÕES</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentPageLogs.map((log, index) => (
                                    <tr key={log._id || index}>
                                        <td>
                                            <div className="date-cell">
                                                <span className="date-full">{formatDate(log.data)}</span>
                                                <span className="date-relative">{getRelativeTime(log.data)}</span>
                                            </div>
                                        </td>
                                        <td>
                                            <span className="tipo-badge" style={{
                                                backgroundColor: getTipoColor(log.tipo) + '20',
                                                color: getTipoColor(log.tipo)
                                            }}>
                                                {getTipoIcon(log.tipo)} {log.tipo || 'Outros'}
                                            </span>
                                        </td>
                                        <td>
                                            <span className="acao-cell">{log.acao || '-'}</span>
                                        </td>
                                        <td>
                                            <span className="usuario-cell">
                                                {log.usuarioNome || 'Sistema'}
                                                {log.usuarioEmail && (
                                                    <span className="usuario-email">{log.usuarioEmail}</span>
                                                )}
                                            </span>
                                        </td>
                                        <td>
                                            <span className="detalhes-cell">
                                                {log.detalhes ? (
                                                    log.detalhes.length > 60 ?
                                                        `${log.detalhes.substring(0, 60)}...` :
                                                        log.detalhes
                                                ) : '-'}
                                            </span>
                                        </td>
                                        <td>
                                            <div className="action-buttons">
                                                <button
                                                    className="btn-view"
                                                    onClick={() => openLogDetails(log)}
                                                    title="Ver detalhes"
                                                >
                                                    <Icon name="visibility" size={16} />
                                                </button>
                                                <button
                                                    className="btn-delete"
                                                    onClick={() => openDeleteSingleConfirm(log)}
                                                    title="Apagar este log"
                                                >
                                                    <Icon name="delete" size={16} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        {/* PAGINAÇÃO */}
                        {renderPagination()}
                    </>
                )}
            </div>

            {/* MODALS */}
            {renderDetailsModal()}
            {renderExportModal()}
            {renderDeleteConfirmModal()}
            {renderToast()}
        </div>
    );
}